<div id="evaluation-container" class="container">

    <div class="row">
        <div class="col-xs-12 table-responsive list-sessions">
            <h3>
                {{ 'training-detail.evaluations.futureSessions' | translate:{ futureSessionCount: futureSessions.length } }}
            </h3>
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <th style="width: 20%">{{'training-detail.evaluations.trainer' | translate}}</th>
                    <th>{{'training-detail.evaluations.startDate' | translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let session of futureSessions" class="session-line"
                    uiSref="session-detail" [uiParams]="{ id: session.id }">
                    <td style="user-select: none">
                        <a>
                            <span *ngIf="session.trainer">{{session.trainer.firstName}} {{session.trainer.lastName}}</span>
                            <span *ngIf="!session.trainer">À définir</span>
                        </a>
                    </td>
                    <td>
                        <a>{{session.startDate | formatdatepipe}}</a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-12" style="margin-top: 25px;">
            <h3>
                {{ 'training-detail.evaluations.evaluationAverages' | translate:{ evaluationCount: evaluations.aggregate.count } }}
            </h3>
            <div class="col-sm-2">
                {{'session-details.evaluations.trainingContent' | translate}} : <strong>{{evaluations.aggregate.averages.contentRichness | number:'1.1-1'}}</strong>
            </div>
            <div class="col-sm-2">
                {{'session-details.evaluations.trainingExamples' | translate}} : <strong>{{evaluations.aggregate.averages.examples | number:'1.1-1'}}</strong>
            </div>
            <div class="col-sm-3">
                {{'session-details.evaluations.trainingLayout' | translate}} : <strong>{{evaluations.aggregate.averages.layout | number:'1.1-1'}}</strong>
            </div>
            <div class="col-sm-2">
                {{'session-details.evaluations.trainingLabs' | translate}} : <strong>{{evaluations.aggregate.averages.practiceInterest | number:'1.1-1'}}</strong>
            </div>
            <div class="col-sm-3">
                {{'session-details.evaluations.trainingRatio' | translate}} : <strong>{{evaluations.aggregate.averages.theoryPracticeRatio | number:'1.1-1'}}</strong>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-xs-12 table-responsive list-sessions">
            <h3>
                {{ 'training-detail.evaluations.pastSessions' | translate:{ pastSessionCount: pastSessions.length } }}
            </h3>
            <table class="table table-striped table-hover">
                <thead>
                <tr>
                    <th>{{'training-detail.evaluations.trainer' | translate}}</th>
                    <th>{{'training-detail.evaluations.startDate' | translate}}</th>
                    <th>{{'training-detail.evaluations.evaluationCount' | translate}}</th>
                    <th>{{'session-details.evaluations.trainingContent' | translate}}</th>
                    <th>{{'session-details.evaluations.trainingExamples' | translate}}</th>
                    <th>{{'session-details.evaluations.trainingLayout' | translate}}</th>
                    <th>{{'session-details.evaluations.trainingLabs' | translate}}</th>
                    <th>{{'session-details.evaluations.trainingRatio' | translate}}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let session of pastSessions" class="session-line"
                    uiSref="session-detail" [uiParams]="{ id: session.id }">
                    <td style="user-select: none">
                        <a>
                            <span *ngIf="session.trainer">{{session.trainer.firstName}} {{session.trainer.lastName}}</span>
                            <span *ngIf="!session.trainer">Non défini</span>
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.startDate | formatdatepipe}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.evaluations.aggregate.count}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.evaluations.aggregate.averages.contentRichness | number:'1.1-1'}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.evaluations.aggregate.averages.examples | number:'1.1-1'}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.evaluations.aggregate.averages.layout | number:'1.1-1'}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.evaluations.aggregate.averages.practiceInterest | number:'1.1-1'}}
                        </a>
                    </td>
                    <td>
                        <a>
                            {{session.evaluations.aggregate.averages.theoryPracticeRatio | number:'1.1-1'}}
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/evaluation/evaluation.component.html